<template>
    <MainContent :title="'Detalle del ' + configuracion.simpatizante">
        <template v-slot:header>
            <h3 v-if="abonado" class="card-title">Datos del {{ configuracion.simpatizante }}: {{ abonado.nombre }} {{ abonado.apellidos }}</h3>
            <div v-if="abonado" class="card-tools">
                <div :class="'btn-group ' + (expand != false ? 'show' : '')">
                    <Button type="button" class="dropdown-toggle" @click.prevent="expandir">OPCIONES</Button>
                    <div :class="'dropdown-menu ' + (expand != false ? 'show' : '')">
                        <router-link
                            :to="{ name: 'back.simpatizantes.editar', params: { simpatizante_id: abonado.id}}"
                            class="dropdown-item"
                        >
                            Editar
                        </router-link>
                        <a class="dropdown-item" href="#" @click="validar(simpatizante_id)">Validar</a>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:content>
            <LoaderComponent v-if="loading" />
            <div class="row">
                <div class="col-12">
                    <ul v-if="abonado && !loading" class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                            <b>Nª de pedido:</b> <a>{{ abonado.n_pedido }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Nombre: </b> <a>{{ abonado.nombre }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Apellidos: </b> <a>{{ abonado.apellidos }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Precio: </b> <a>{{ abonado.precio | formatear_precio }}</a>
                        </li>
                        <li class="list-group-item" v-if="abonado.descuento > 0">
                            <b>Descuento: </b> <a>{{ abonado.descuento | formatear_precio }}</a>
                        </li>
                        <li class="list-group-item" v-if="abonado.total > 0">
                            <b>Total: </b> <a>{{ abonado.total | formatear_precio }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Estado: </b> <a>{{ abonado.estado_nombre }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Fecha: </b> <a>{{ abonado.fecha }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Pais: </b> <a>{{ abonado.pais }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Localidad: </b> <a>{{ abonado.ciudad }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Dirección: </b> <a>{{ abonado.direccion }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Codigo postal: </b> <a>{{ abonado.codigo_postal }}</a>
                        </li>
                        <li class="list-group-item" v-if="abonado.rmu_code">
                            <b>Mu code: </b> <a>{{ abonado.rmu_code }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Metodo de pago: </b> <a>{{ abonado.metodo_pago | formatear_metodo_pago }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Teléfono: </b> <a>{{ abonado.telefono }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>DNI: </b> <a>{{ abonado.dni }}</a>
                        </li>
                        <li class="list-group-item">
                            <b>Email: </b> <a>{{ abonado.email }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import LoaderComponent from '../../../components/preloader/LoaderComponent.vue';
    export default {
        props: ['simpatizante_id'],
        data() {
            return {
                abonado: null,
                loading: true,
                expand: false
            }
        },
        created() {
            this.getAbonado();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
        },
        methods: {
            getAbonado : function() {
                this.loading = true;

                const params = {
                    filters : {},
                    simpatizante_id: this.simpatizante_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.show'), params).then(res => {
                    this.abonado = res.data.data;
                }).finally(() => this.loading = false);
            },
            expandir() {
                if(this.expand) {
                    this.expand = false;
                } else {
                    this.expand = true;
                }
            },
            validar(id) {
                this.loading = true;

                const params = {
                    filters : {},
                    simpatizante_id: id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.validar'), params).then(res => {
                    this.expand = false;
                    this.$toast.success(res.data.message);
                    this.getAbonado();
                }).finally(() => this.loading = false);
            },
        },
        components: {
            MainContent,
            LoaderComponent
        }
    }
</script>
